import {Component, Module} from 'app/decorators';

import _ from 'lodash';
import tpl from './print.button.html';
import {PrinterListModalCtrl} from 'app/printers/ctrls';
import printModalTpl from 'app/printers/modal.list.html';


@Module({
    name: "app.directives.print.button.component",
})
@Component({
    selector: 'blnd-print-button',
    template: tpl,
    bindings: {
        ngModel: '=',
        ngDisabled: '=?',
        type: "@",
        multiple: "=?",
        table: '<',
    },
})
export default class C {
    constructor ($growl, Modal) {
        "ngInject";

        this.$growl = $growl;
        this.Modal = Modal;
    }

    print (type) {
        let self = this;

        let $modal = this.Modal.open({
            template: printModalTpl,
            controller: PrinterListModalCtrl,
            size: 'large',
            resolve: {
                company: () => _.first(self.ngModel).company.id,
                request: () => {
                    return {
                        endpoint: undefined,
                        type: type,
                        orders: self.ngModel,
                        multiple: true
                    }
                }
            }
        });

        $modal.result.then(function(data){
            let msg = data === 1 ? `1 file` : `${data} files`;
            self.$growl.success(`Added ${msg} to queue`);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/print.button/component.js